var _path, _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "youtube_svg__a",
    width: 25,
    height: 22,
    x: 16,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16 17h24.696v21.837H16V17Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#youtube_svg__b)",
    fillRule: "evenodd",
    d: "M25.262 32.955v-9.49l8.815 4.745-8.815 4.745ZM36.082 17H20.614C18.065 17 16 19.089 16 21.665v12.508c0 2.576 2.065 4.665 4.614 4.665h15.468c2.549 0 4.615-2.09 4.615-4.665V21.665c0-2.576-2.066-4.665-4.615-4.665Z",
    clipRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    stroke: "#00CA72",
    rx: 27.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "youtube_svg__b",
    x1: 40.998,
    x2: 15.987,
    y1: 27.581,
    y2: 27.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgYoutube;